export const roundToDecimals = (number: number, decimals: number): number => Math.round(number * 10 ** decimals) / 10 ** decimals;
